module.exports = __webpack_public_path__ + "img/wedding-newborn-job.59942712.png";